import { UIMessage } from 'ai';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

export const getChatHistory = async (
  userId: string,
  config?: AxiosRequestConfig
): Promise<{ createdAt: Date; id: string; title: string }[]> => {
  try {
    const response = await Gateway.get(`/core/v1/chat`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getChat = async (
  chatId: string,
  config?: AxiosRequestConfig
): Promise<(Pick<UIMessage, 'role' | 'id'> & { content: string })[]> => {
  try {
    const response = await Gateway.get(`/core/v1/chat/${chatId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const deleteChat = async (
  chatId: string,
  config?: AxiosRequestConfig
): Promise<{ role: 'user' | 'assistant'; content: string }[]> => {
  try {
    const response = await Gateway.delete(`/core/v1/chat/${chatId}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
